import React, { useContext } from "react";
import { depascalize, Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { MuxerType } from "../../../../common/types/MuxerType";
import { LanguageSpecificationType } from "../../../common/types/LanguageSpecificationType";
import { MuxSpecificationDashboardContext } from "../context/MuxSpecificationDashboardContext";
import { ensureIsManzanitaMuxSpecification } from "../MuxSpecificationDashboardItem";

export const ManzanitaMuxSpecificationInfoContent: React.FunctionComponent = () => {
    const { muxSpecificationDashboardItem } = useContext(MuxSpecificationDashboardContext);
    ensureIsManzanitaMuxSpecification(muxSpecificationDashboardItem);

    return (
        <Grid>
            <GridRow>
                <GridColumn lg={12}>
                    <LabeledText label="Name" value={muxSpecificationDashboardItem.name} />
                    <LabeledText label="Muxer Type" value={depascalize(MuxerType[MuxerType.Manzanita])} />
                    <LabeledText
                        label="Language Specification Type"
                        value={getLanguageSpecificationType(muxSpecificationDashboardItem.languageSpecification.type)}
                    />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};

const getLanguageSpecificationType = (languageSpecificationType: LanguageSpecificationType): string => {
    return depascalize(LanguageSpecificationType[languageSpecificationType]);
};
